export enum PermissionFlag {
	None = 0,
	View = 1 << 0,
	Edit = 1 << 1,
}
export const FullPermission: PermissionFlag = PermissionFlag.View | PermissionFlag.Edit;
